import React, { useState } from 'react';

function SidebarLinkGroup({
  children,
  activecondition,
}) {

  const [open, setOpen] = useState(activecondition);

  const handleClick = () => {
    setOpen(!open);
  }

  return (
    <li className={`rounded-sm mb-[30px] last:mb-0 ${activecondition && 'bg-red hover-active-color'}`}>
      {children(handleClick, open)}
    </li>
  );
}

export default SidebarLinkGroup;